const predefinedTags = [
  'Technology',
  'Web Development',
  'React',
  'JavaScript',
  'CSS',
  'Design',
  'UI/UX',
  'Programming',
  'Tutorial',
  'Tips',
  'Career',
  'Personal',
  'Industry News',
  'Best Practices',
  'AI',
];

export { predefinedTags };
